import React, { memo } from 'react';
import { array, bool, string } from 'prop-types';
import pick from 'lodash/pick';
import OrderLineGroups from '../OrderLineGroups';
import OrderLines from '../OrderLines';
import TransferGroups from '../TransferGroups';
import OrderAmounts from '../OrderAmounts';
import OrderAmountsWithPartingLine from '../OrderAmountsWithPartingLine';
import OrderLineTitle from '../OrderLineTitle';

const OrderViewMode = ({
  orderLineGroups, orderLines, currencyCode,
  identifier, isShowOrderAmount, transferPairList,
  orderLineFieldsConfig, orderReviewModel,
  isShowButtonCol, isShowPartingLineAmountsSection,
  ...rest
}) => {
  if (orderLineGroups) {
    return <OrderLineGroups
      orderLineGroups={orderLineGroups}
      currencyCode={currencyCode}
      checkoutOrderIdentifier={identifier}
      orderLineFieldsConfig={orderLineFieldsConfig}
      isShowButtonCol={isShowButtonCol}
      {...pick(rest, [ 'handleOrderReviewCallback', 'orderReviewHandleableConfig', 'trackingCallback' ])}/>;
  }

  if (transferPairList) {
    return <TransferGroups
      transferPairList={transferPairList}
      currencyCode={currencyCode}
      orderLineFieldsConfig={orderLineFieldsConfig}/>;
  }

  return (
    <div className="order-structure">
      <OrderLineTitle
        className="orderline-group__title"
        descriptionTitleId={`${orderReviewModel === 'ORDERLINE_GROUP'
          ? 'checkout.lib.components.common.text.orders'
          : 'checkout.lib.components.text.items'}`}
        amountTitleId={'checkout.lib.components.orderDetailContent.amountTitle'}
        orderLineFieldsConfig={orderLineFieldsConfig}
        isShowButtonCol={isShowButtonCol}/>
      <OrderLines orderLines={orderLines}
        currencyCode={currencyCode}
        checkoutOrderIdentifier={identifier}
        orderLineFieldsConfig={orderLineFieldsConfig}
        isShowButtonCol={isShowButtonCol}
        {...pick(rest, [ 'handleOrderReviewCallback', 'orderReviewHandleableConfig', 'trackingCallback' ])}/>
      { isShowOrderAmount
         && <div className='order-structure__amount'>
           { isShowPartingLineAmountsSection ? <OrderAmountsWithPartingLine {...rest}/> : <OrderAmounts
             currencyCode={currencyCode}
             {...rest}/>}
         </div>
      }
    </div>
  );
};

OrderViewMode.propTypes = {
  orderLines: array,
  orderLineGroups: array,
  transferPairList: array,
  isShowOrderAmount: bool,
  currencyCode: string.isRequired,
  identifier: string,
};

OrderViewMode.defaultProps = {
  isShowOrderAmount: true,
};

export default memo(OrderViewMode);
